import { useEffect, useState } from "react";
import { Users, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatError } from "../lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

export default function Dependents() {
  const [items, setItems] = useState([]);
  const [dlg, setDlg] = useState(false);
  const [form, setForm] = useState({ name: "", relationship: "hijo", birth_date: "", nif: "", notes: "" });
  const load = () => api.get("/dependents").then(({ data }) => setItems(data || []));
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (!form.name) { toast.error("Nombre requerido"); return; }
    try {
      await api.post("/dependents", form);
      toast.success("Familiar añadido"); setDlg(false); setForm({ name: "", relationship: "hijo", birth_date: "", nif: "", notes: "" }); load();
    } catch (e) { toast.error(formatError(e)); }
  };
  const remove = async (id) => {
    if (!window.confirm("¿Eliminar este familiar?")) return;
    await api.delete(`/dependents/${id}`); load();
  };
  return (
    <div className="space-y-6 fade-up" data-testid="dependents-page">
      <div className="flex justify-between">
        <h1 className="font-display text-3xl flex items-center gap-2"><Users className="w-7 h-7 text-emerald-700" /> Mis familiares</h1>
        <Button onClick={() => setDlg(true)} className="bg-emerald-700 hover:bg-emerald-800" data-testid="add-dep-btn"><Plus className="w-4 h-4 mr-1" /> Añadir familiar</Button>
      </div>
      <p className="text-sm text-muted-foreground">Gestiona las citas y la historia de tus dependientes (hijos menores, padres, cónyuge...).</p>
      <div className="grid md:grid-cols-2 gap-4">
        {items.map((d) => (
          <Card key={d.id} data-testid={`dep-${d.id}`}>
            <CardContent className="p-4 flex items-start justify-between">
              <div>
                <div className="font-medium">{d.name}</div>
                <div className="text-xs text-muted-foreground capitalize">{d.relationship}{d.birth_date ? ` · Nac. ${d.birth_date}` : ""}</div>
                {d.nif && <div className="text-xs text-muted-foreground">DNI: {d.nif}</div>}
              </div>
              <Button size="icon" variant="ghost" className="text-red-600" onClick={() => remove(d.id)} data-testid={`del-dep-${d.id}`}><Trash2 className="w-4 h-4" /></Button>
            </CardContent>
          </Card>
        ))}
        {items.length === 0 && <div className="text-sm text-muted-foreground col-span-2 text-center py-8 border border-dashed rounded-lg">Sin familiares registrados</div>}
      </div>
      <Dialog open={dlg} onOpenChange={setDlg}>
        <DialogContent data-testid="dep-dialog">
          <DialogHeader><DialogTitle>Añadir familiar</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>Nombre completo</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="dep-name" /></div>
            <div>
              <Label>Parentesco</Label>
              <Select value={form.relationship} onValueChange={(v) => setForm({ ...form, relationship: v })}>
                <SelectTrigger data-testid="dep-relationship"><SelectValue /></SelectTrigger>
                <SelectContent>
                  {["hijo", "hija", "padre", "madre", "conyuge", "otro"].map((r) => <SelectItem key={r} value={r} className="capitalize">{r}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
            <div><Label>Fecha de nacimiento</Label><Input type="date" value={form.birth_date} onChange={(e) => setForm({ ...form, birth_date: e.target.value })} /></div>
            <div><Label>DNI / NIE</Label><Input value={form.nif} onChange={(e) => setForm({ ...form, nif: e.target.value })} /></div>
            <div><Label>Notas</Label><Input value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} placeholder="Alergias, medicación..." /></div>
          </div>
          <DialogFooter>
            <Button variant="ghost" onClick={() => setDlg(false)}>Cancelar</Button>
            <Button onClick={save} className="bg-emerald-700 hover:bg-emerald-800" data-testid="dep-submit">Guardar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
